export default "__VITE_ASSET__DRboYOWw__"